import * as React from "react";
import {Image} from "@models/image";
import {Icon, Modal} from "antd";
import Col from "antd/lib/grid/col";
import ImageForm from "@components/images/Form";
import ImagePreview from "../custom/ImagePreview";

type Props = {
  image: Image;
  onClick?: (item: Image) => void;
  deleteFn?: (item: Image) => void; //Delete icon would be rendered if deleteFn pass as a props
  canEdit: Boolean
  canDelete: Boolean
};

const ColProps = {
  xs: 12,
  sm: 8,
  md: 8,
  lg: 6,
  xl: 6
};

const ImagesItem: React.FC<Props> = props => {
  const {image, onClick, deleteFn, canEdit, canDelete} = props;
  
  const onClickImage = (event) => {
    if(event.target.closest('.ignore-inner-click') || event.target.closest('.image-preview-modal')){
      return;
    }
    onClick && onClick(image);
  };
  
  return (
    <Col {...ColProps} className={`image-box-wrapper`}>
      
      <div
        className={`image-box`}
        style={{backgroundImage: `url(${image.path})`}}
        onClick={onClickImage}
      >
        
        <div className={`image-hover-box`}>
          <div className={'image-actions-wrapper'}>
            { canEdit && (
              <ImageForm image={image} toggleButton={(
                <Icon type="edit"/>
              )}/>
            )}
           
            {canDelete && (
              <Icon type="delete" onClick={() => deleteFn(image)}/>
            )}
            
            <ImagePreview src={image.path}/>
            
          </div>
          <div className="image-box-bottom">
            <span className={`image-title`}>{image.title}</span>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default ImagesItem;
